<div class="left-sidenav">
  <ul class="list-unstyled">
    <li [class.active-route]="router.url.includes('homepage')">
      <a routerLink="/" (click)="closeLeftSidenav.emit()">
        <i class="menu-icon fa fa-home position-relative"></i>
        <span> HOMEPAGE </span>
        <i class="fa fa-chevron-right position-absolute text-secondary"></i>
      </a>
    </li>
    <li routerLinkActive="active-route">
      <a routerLink="/races" (click)="closeLeftSidenav.emit()">
        <i class="menu-icon fa fa-flag position-relative"></i>
        <span> All RACES </span>
        <i class="fa fa-chevron-right position-absolute text-secondary"></i>
      </a>
    </li>
 <!--    <li>
      <a href="/" (click)="closeLeftSidenav.emit()">
        <i class="menu-icon fa fa-eye position-relative"></i>
        <span> LIVE STREAMS </span>
        <i class="fa fa-chevron-right position-absolute text-secondary"></i>
      </a>
    </li> -->
    <li>
      <a routerLink="/next-races" (click)="closeLeftSidenav.emit()">
        <i class="menu-icon fa fa-plus position-relative"></i>
        <span> NEXT RACES </span>
        <i class="fa fa-chevron-right position-absolute text-secondary"></i>
      </a>
    </li>
  </ul>
</div>
